class ApiError extends Error {
  constructor(
    message?: string,
    public code?: number
  ) {
    super(message || 'Bad request');
    this.name = 'Bad request';
    this.code = code || 400;
  }
}

export default ApiError;
